import { ExpectedEffectiveValues } from '@hkm/shared/effectiveValues/expectedEffectiveValues';

export const HousekeepingEffectiveValues: ExpectedEffectiveValues = new Map()
  .set('enableHousekeepingMobileApplication', true);



// WEBPACK FOOTER //
// ./src/components/Housekeeping/shared/config/housekeepingEffectiveValues.ts